<template>
  <teleport to="body">
    <div @click="$emit('waiting')"></div>
    <dialog open @click="$emit('waiting')">
      <header :style="styles">
        <slot name="header">
          <h2>{{ title }}</h2>
        </slot>
      </header>
      <section>
        <slot></slot>
      </section>
    </dialog>
  </teleport>
</template>

<script>
export default {
  emits: ['waiting', 'close'],
  props: {
    title: { type: String, required: false },
    visibility: { type: Boolean, required: false },

    updated() {
      //   console.log('this visibility', this.visibility);
    },
  },

  data() {
    return {
      currentRoute: null,
      currentPath: null,
      isBusiness: false,
    };
  },
  watch: {
    currentRoute() {
      this.currentPath = this.currentRoute.path;

      if (this.currentPath.toLowerCase().indexOf('fchq') >= 0) {
        this.isBusiness = true;
      }
      if(this.currentRoute.query.page === 'meeting-rooms' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0 ||
      this.currentRoute.query.page === 'community-spaces' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0 ||
      this.currentRoute.query.page === 'creative-studio' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0) {
        this.isBusiness = true;
      }
      if (this.currentPath.toLowerCase().indexOf('futsal') >= 0) {
        this.isBusiness = false;
      } else {
        // console.log('No.01');
      }
    },
  },

  computed: {
    styles: function () {
      if (this.isBusiness === true) {
        return {
          'background-color': '#c9c2c0',
        };
      } else {
        return {
          'background-color': '#00509e',
        };
      }
    },
  },
  beforeMount() {
    this.currentRoute = this.$router.currentRoute;
    //    console.log(' current host dialog', location.host);
  },
};
</script>

<style scoped>
div {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 10;
  margin-bottom: 0;
}

dialog {
  position: fixed;
  top: 20vh;
  left: 10%;
  width: 80%;
  z-index: 100;

  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0;
  margin: 0;
  overflow: hidden;
}

header {
  width: 100%;
  padding: 1rem;
}

header h2 {
  margin: 0;
  color: white;
}

section {
  padding: 1rem;
}

menu {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  margin: 0;
}

@media (min-width: 768px) {
  dialog {
    left: calc(50% - 20rem);
    width: 35rem;
  }
}
</style>
